export const weatherRouteRows = [
  // 航行通告
  {
    path: "/weather/information_notice",
    name: "information_notice",
    meta: {
      type: 1,
      isKeepAlive: true,
      title: "航行通告",
    },
    component: () =>
      import("@/components/information_notice_warning/index.vue"),
  },
  // 航行警告
  {
    path: "/weather/information_warning",
    name: "information_warning",
    meta: {
      type: 2,
      isKeepAlive: true,
      title: "航行警告",
    },
    component: () =>
      import("@/components/information_notice_warning/index.vue"),
  },
  // 航行详情
  {
    path: "/weather/information_details",
    name: "information_details",
    meta: {
      isKeepAlive: false,
      title: "航行详情",
    },
    component: () =>
      import("@/components/information_notice_warning/detail/detail.vue"),
  },
  // 任意点气象
  {
    path: "/weather/random_weather",
    name: "random_weather",
    meta: {
      isKeepAlive: false,
      title: "任意点气象",
    },
    component: () => import("@/components/random_weather/index.vue"),
  },
  // 台风路径
  {
    path: "/weather/typhoon_path",
    name: "typhoon_path",
    meta: {
      isKeepAlive: false,
      title: "台风路径",
    },
    component: () => import("@/components/typhoon_path/index.vue"),
  },
  // 潮汐查询
  {
    path: "/weather/tide_query",
    name: "tide_query",
    meta: {
      isKeepAlive: false,
      title: "潮汐查询",
    },
    component: () => import("@/components/tide_query/index.vue"),
  },
  // 渔区预报
  {
    path: "/weather/fishing_area_forecast",
    name: "fishing_area_forecast",
    meta: {
      isKeepAlive: false,
      title: "渔区预报",
    },
    component: () => import("@/components/fishing_area_forecast/index.vue"),
  },
  // 渔区预报详情
  {
    path: "/weather/fishing_area_detail",
    name: "fishing_area_detail",
    meta: {
      isKeepAlive: false,
      title: "预报详情",
    },
    component: () => import("@/components/fishing_area_forecast/detail.vue"),
  },
  // 关注气象
  {
    path: "/weather/collect_meteorological",
    name: "collect_meteorological",
    meta: {
      isKeepAlive: false,
      title: "关注气象",
    },
    component: () => import("@/components/collect_meteorological/index.vue"),
  },
  // 气象详情
  {
    path: "/weather/weather_detail",
    name: "weather_detail",
    meta: {
      isKeepAlive: false,
      title: "气象详情",
    },
    component: () => import("@/components/collect_meteorological/detail.vue"),
  },
  // 气象分享
  {
    path: "/weather/share_weather",
    name: "share_weather",
    meta: {
      isKeepAlive: false,
      title: "气象详情",
    },
    component: () => import("@/components/share-weather/index.vue"),
  },
  // 多家预报参考

  //   水文气象
  {
    path: "/swqx",
    name: "swqx",
    meta: {
      isKeepAlive: false,
      title: "水文气象",
    },
    component: () => import("@/components/swqx/index.vue"),
  },
];
